import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container pb-4" }

import TheNavBar from "@/components/TheNavBar.vue";
import { computed } from "vue";
import { useStore } from "vuex";
import { StateStatus } from "@/store/type";
import TheInitializing from "@/components/TheInitializing.vue";
import TheUnderDevelopmentPreHeader from "@/components/TheUnderDevelopmentPreHeader.vue";
import AppNotification from "@/components/app/AppNotification.vue";
import TheScrollToTop from "@/components/TheScrollToTop.vue";
import ThePageSizeMarker from "@/components/ThePageSizeMarker.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();

const isDevelopment = process.env.NODE_ENV !== "production"
const isInitializing = computed(() => store.getters["auth/getInitStatus"] === StateStatus.IN_PROGRESS)

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    isDevelopment
      ? (_openBlock(), _createBlock(ThePageSizeMarker, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(isInitializing))
      ? (_openBlock(), _createBlock(TheInitializing, { key: 1 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createVNode(TheNavBar),
          _createVNode(TheUnderDevelopmentPreHeader),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_router_view)
          ])
        ], 64)),
    _createVNode(AppNotification),
    _createVNode(TheScrollToTop)
  ], 64))
}
}

})